export default __webpack_public_path__ + "345079090860c7908c5a0dc0220bf023.png";